import { TransitionDirection, TransitionKind } from "@repo/api/transition";
import {
  getDefaultDurationInFrames,
  getDefaultPreviewClipDurationsInFrames,
  getDefaultTiming,
  ImageTransitionBuilder,
} from "./ImageTransitionBuilder.ts";
import { wipe, WipeDirection, WipeProps } from "@remotion/transitions/wipe";

const transitionKind = TransitionKind.enum.WIPE;

const remotionDirections: Record<TransitionDirection, WipeDirection> = {
  FROM_LEFT: "from-left",
  FROM_RIGHT: "from-right",
  FROM_TOP: "from-top",
  FROM_BOTTOM: "from-bottom",
  FROM_TOP_RIGHT: "from-top-right",
  FROM_TOP_LEFT: "from-top-left",
  FROM_BOTTOM_RIGHT: "from-bottom-right",
  FROM_BOTTOM_LEFT: "from-bottom-left",
};

export const ImageWipeTransitionBuilder: ImageTransitionBuilder<WipeProps> = {
  formConfig: {
    kind: transitionKind,
    buildDefaultValue: () => ({
      kind: transitionKind,
      speed: "NORMAL",
      direction: "FROM_LEFT",
    }),
    speed: ["SLOW", "NORMAL", "FAST"],
    direction: [
      "FROM_LEFT",
      "FROM_RIGHT",
      "FROM_TOP",
      "FROM_BOTTOM",
      "FROM_TOP_RIGHT",
      "FROM_TOP_LEFT",
      "FROM_BOTTOM_RIGHT",
      "FROM_BOTTOM_LEFT",
    ],
  },

  transition: {
    getDurationInFrames: getDefaultDurationInFrames,
    buildPresentation: (props) =>
      wipe({
        direction: remotionDirections[props.imageTransition.direction!],
      }),
    buildTiming: getDefaultTiming,
  },

  getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
};
